export default __webpack_public_path__ + "static/media/JoinTheAcrocalypse-Mobile.69afa334.png";